import { ObjectValues } from '../types';
import { sizes as TextSizes } from '../text/text.types';
import { ReactElement } from 'react';

export const sizes = {
  xs: TextSizes.interface,
  s: TextSizes.small,
  m: TextSizes.basic,
  l: TextSizes.large,
} as const;

export const variants = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  positive: 'positive',
  attention: 'attention',
  negative: 'negative',
  neutral: 'neutral',
  information: 'information',
  featured: 'featured',
} as const;

export type Tag = {
  text: string;
  border?: boolean;
  size?: ObjectValues<typeof sizes>;
  variant?: ObjectValues<typeof variants>;
  icon?: ReactElement;
};
